// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/customer_service.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ProcessImageColorResponseSchema, ProcessImageParameters, ProcessImageRequestSchema } from "../../ai_color_simulation/v1/messages_pb";
import { file_ai_color_simulation_v1_messages } from "../../ai_color_simulation/v1/messages_pb";
import type { GetDealWithColorSimulationResponse, ToggleColorSimulationImageFavoriteRequestSchema, ToggleColorSimulationImageFavoriteResponseSchema, UpdateColorSimulationImageTitleRequestSchema, UpdateColorSimulationImageTitleResponseSchema } from "./ai_color_simulation_pb";
import { file_api_proto_v1_ai_color_simulation } from "./ai_color_simulation_pb";
import type { ListSharedCompanyColorsRequestSchema, ListSharedCompanyColorsResponseSchema } from "./color_pb";
import { file_api_proto_v1_color } from "./color_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/customer_service.proto.
 */
export const file_api_proto_v1_customer_service: GenFile = /*@__PURE__*/
  fileDesc("CiNhcGlfcHJvdG8vdjEvY3VzdG9tZXJfc2VydmljZS5wcm90bxIMYXBpX3Byb3RvLnYxIiYKJEdldENvbG9yU2ltdWxhdGlvbkJ5U2hhcmVMaW5rUmVxdWVzdCKkAgolR2V0Q29sb3JTaW11bGF0aW9uQnlTaGFyZUxpbmtSZXNwb25zZRJECgpzaW11bGF0aW9uGAEgASgLMjAuYXBpX3Byb3RvLnYxLkdldERlYWxXaXRoQ29sb3JTaW11bGF0aW9uUmVzcG9uc2USLgoKZXhwaXJlc19hdBgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASQgoKcGFyYW1ldGVycxgDIAEoCzIuLmFpX2NvbG9yX3NpbXVsYXRpb24udjEuUHJvY2Vzc0ltYWdlUGFyYW1ldGVycxISCgpjb21wYW55X2lkGAQgASgDEhcKD2FuY2hvcl9pbWFnZV9pZBgFIAEoAxIUCgxjb21wYW55X25hbWUYBiABKAkyuQUKD0N1c3RvbWVyU2VydmljZRKNAQodR2V0Q29sb3JTaW11bGF0aW9uQnlTaGFyZUxpbmsSMi5hcGlfcHJvdG8udjEuR2V0Q29sb3JTaW11bGF0aW9uQnlTaGFyZUxpbmtSZXF1ZXN0GjMuYXBpX3Byb3RvLnYxLkdldENvbG9yU2ltdWxhdGlvbkJ5U2hhcmVMaW5rUmVzcG9uc2UiA5ACARKXAQoiVG9nZ2xlQ29sb3JTaW11bGF0aW9uSW1hZ2VGYXZvcml0ZRI3LmFwaV9wcm90by52MS5Ub2dnbGVDb2xvclNpbXVsYXRpb25JbWFnZUZhdm9yaXRlUmVxdWVzdBo4LmFwaV9wcm90by52MS5Ub2dnbGVDb2xvclNpbXVsYXRpb25JbWFnZUZhdm9yaXRlUmVzcG9uc2USjgEKH1VwZGF0ZUNvbG9yU2ltdWxhdGlvbkltYWdlVGl0bGUSNC5hcGlfcHJvdG8udjEuVXBkYXRlQ29sb3JTaW11bGF0aW9uSW1hZ2VUaXRsZVJlcXVlc3QaNS5hcGlfcHJvdG8udjEuVXBkYXRlQ29sb3JTaW11bGF0aW9uSW1hZ2VUaXRsZVJlc3BvbnNlEm4KDFByb2Nlc3NJbWFnZRIrLmFpX2NvbG9yX3NpbXVsYXRpb24udjEuUHJvY2Vzc0ltYWdlUmVxdWVzdBoxLmFpX2NvbG9yX3NpbXVsYXRpb24udjEuUHJvY2Vzc0ltYWdlQ29sb3JSZXNwb25zZRJ7ChdMaXN0U2hhcmVkQ29tcGFueUNvbG9ycxIsLmFwaV9wcm90by52MS5MaXN0U2hhcmVkQ29tcGFueUNvbG9yc1JlcXVlc3QaLS5hcGlfcHJvdG8udjEuTGlzdFNoYXJlZENvbXBhbnlDb2xvcnNSZXNwb25zZSIDkAIBQjNaMWdpdGh1Yi5jb20vaC1zY2FwZS9pZXNhcHVyaS9nby9hcGlfcHJvdG8vdjE7YXBpdjFiBnByb3RvMw", [file_ai_color_simulation_v1_messages, file_api_proto_v1_ai_color_simulation, file_api_proto_v1_color, file_google_protobuf_timestamp]);

/**
 * 共有リンクからカラーシミュレーション情報を取得するリクエスト
 * トークンはミドルウェアで認証済みのため、リクエストボディは空
 *
 * @generated from message api_proto.v1.GetColorSimulationByShareLinkRequest
 */
export type GetColorSimulationByShareLinkRequest = Message<"api_proto.v1.GetColorSimulationByShareLinkRequest"> & {
};

/**
 * Describes the message api_proto.v1.GetColorSimulationByShareLinkRequest.
 * Use `create(GetColorSimulationByShareLinkRequestSchema)` to create a new message.
 */
export const GetColorSimulationByShareLinkRequestSchema: GenMessage<GetColorSimulationByShareLinkRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_customer_service, 0);

/**
 * 共有リンクからカラーシミュレーション情報を取得するレスポンス
 *
 * @generated from message api_proto.v1.GetColorSimulationByShareLinkResponse
 */
export type GetColorSimulationByShareLinkResponse = Message<"api_proto.v1.GetColorSimulationByShareLinkResponse"> & {
  /**
   * カラーシミュレーション詳細（SimulationDetailコンポーネントと共通の型）
   *
   * @generated from field: api_proto.v1.GetDealWithColorSimulationResponse simulation = 1;
   */
  simulation?: GetDealWithColorSimulationResponse;

  /**
   * 共有リンクの有効期限
   *
   * @generated from field: google.protobuf.Timestamp expires_at = 2;
   */
  expiresAt?: Timestamp;

  /**
   * 共有リンク作成時にアクティブだった外観カット1枚分のスナップショット。
   * 編集可能エリアの判定には使わない（ListSharedCompanyColors の cuts を使う）。
   *
   * @generated from field: ai_color_simulation.v1.ProcessImageParameters parameters = 3;
   */
  parameters?: ProcessImageParameters;

  /**
   * GTMトラッキング用ID
   *
   * @generated from field: int64 company_id = 4;
   */
  companyId: bigint;

  /**
   * 施主が着地する履歴（生成画像）のID。0=プロジェクト単位のリンク（最新の履歴に着地）。
   * 履歴が削除済みで一覧に無いときもそのまま返す（フロントは一覧に無ければ従来どおり最新の履歴を開く）
   *
   * @generated from field: int64 anchor_image_id = 5;
   */
  anchorImageId: bigint;

  /**
   * 発行元企業の名前（「〇〇から共有された履歴」の帯に使う）
   *
   * @generated from field: string company_name = 6;
   */
  companyName: string;
};

/**
 * Describes the message api_proto.v1.GetColorSimulationByShareLinkResponse.
 * Use `create(GetColorSimulationByShareLinkResponseSchema)` to create a new message.
 */
export const GetColorSimulationByShareLinkResponseSchema: GenMessage<GetColorSimulationByShareLinkResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_customer_service, 1);

/**
 * 施主向けカラーシミュレーションサービス
 *
 * @generated from service api_proto.v1.CustomerService
 */
export const CustomerService: GenService<{
  /**
   * 共有リンクからカラーシミュレーション情報を取得
   *
   * @generated from rpc api_proto.v1.CustomerService.GetColorSimulationByShareLink
   */
  getColorSimulationByShareLink: {
    methodKind: "unary";
    input: typeof GetColorSimulationByShareLinkRequestSchema;
    output: typeof GetColorSimulationByShareLinkResponseSchema;
  },
  /**
   * 施主がお気に入りを切り替え
   *
   * @generated from rpc api_proto.v1.CustomerService.ToggleColorSimulationImageFavorite
   */
  toggleColorSimulationImageFavorite: {
    methodKind: "unary";
    input: typeof ToggleColorSimulationImageFavoriteRequestSchema;
    output: typeof ToggleColorSimulationImageFavoriteResponseSchema;
  },
  /**
   * 施主が履歴のタイトルを更新（issue #2370。共有リンクの範囲内の履歴だけ。ピン留めは施主からは操作できない）
   *
   * @generated from rpc api_proto.v1.CustomerService.UpdateColorSimulationImageTitle
   */
  updateColorSimulationImageTitle: {
    methodKind: "unary";
    input: typeof UpdateColorSimulationImageTitleRequestSchema;
    output: typeof UpdateColorSimulationImageTitleResponseSchema;
  },
  /**
   * 施主がカラーシミュレーションを実行（Go API経由: image_id → S3パス変換を行う）
   *
   * @generated from rpc api_proto.v1.CustomerService.ProcessImage
   */
  processImage: {
    methodKind: "unary";
    input: typeof ProcessImageRequestSchema;
    output: typeof ProcessImageColorResponseSchema;
  },
  /**
   * 共有リンクから企業が使用可能な色一覧を取得
   *
   * @generated from rpc api_proto.v1.CustomerService.ListSharedCompanyColors
   */
  listSharedCompanyColors: {
    methodKind: "unary";
    input: typeof ListSharedCompanyColorsRequestSchema;
    output: typeof ListSharedCompanyColorsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_proto_v1_customer_service, 0);

